import { useRouter } from "next/router";
import React, { useEffect } from "react";

import { useAuth } from "@/custom-hooks/apis-common/use-auth";

import { routePath } from "@/constants/app-paths";
import { authTokenInfoAtom, initializingAtom } from "@/global-states/common-atoms";
import { useAtom } from "jotai";

type Props = {
  children: React.ReactNode;
};

const AuthProvider: React.FC<Props> = (props) => {
  const router = useRouter();
  const { authSync } = useAuth();

  const [authTokenInfo] = useAtom(authTokenInfoAtom);
  const [initializing, setInitializing] = useAtom(initializingAtom);

  useEffect(() => {
    if (!initializing) {
      return;
    }

    (async () => {
      if (await authSync()) {
        if (!router.asPath || router.asPath === routePath) {
          await router.push(routePath);
        }
      }

      setTimeout(() => setInitializing(false), 1);
    })();
  }, [initializing, router.asPath]);

  useEffect(() => {
    const timeout = setTimeout(() => authSync({ silent: true }), 1000 * 60 * 15);
    return () => clearTimeout(timeout);
  }, [authTokenInfo?.accessToken]);

  return <>{props.children}</>;
};

export default AuthProvider;
